import PropTypes from 'prop-types'
import {Text, Box} from '@chakra-ui/react'
import {useTranslation, Trans} from 'react-i18next'

const MembershipDetails = ({memberBusinessName, abn}) => {
  const {t} = useTranslation('points')

  return (
    <Box backgroundColor="mld.neutral.100" p="sm" my="md">
      <Text fontWeight="600">
        {t('points:qantasConnectionDrawer.activeState.membershipDetails.title')}
      </Text>
      <Text>
        <Trans
          i18nKey="points:qantasConnectionDrawer.activeState.membershipDetails.businessName"
          values={{businessName: memberBusinessName}}
          components={{strong: <Text as="span" fontWeight="600" />}}
        />
      </Text>
      <Text>
        <Trans
          i18nKey="points:qantasConnectionDrawer.activeState.membershipDetails.businessNumber"
          values={{businessNumber: abn}}
          components={{strong: <Text as="span" fontWeight="600" />}}
        />
      </Text>
    </Box>
  )
}

MembershipDetails.propTypes = {
  memberBusinessName: PropTypes.string.isRequired,
  abn: PropTypes.string.isRequired,
}

export default MembershipDetails
